import React, { useEffect, useRef, useState } from 'react';
import '.././index.css'; // Import the CSS file containing the keyframes
import companyLocation from './../image/3.png';
import companyLocation1 from './../image/2.png';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import emailjs from '@emailjs/browser';

const ContactUs = ({ title }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    subject: '',
    message: ''
  });
  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [mobileError, setMobileError] = useState('');
  const [subjectError, setSubjectError] = useState('');
  const [messageError, setMessageError] = useState('');
  const form = useRef();

  const isBusinessSolution = title === "Our Process";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    if (formData.name.trim() !== '' && formData.name.trim().length < 3) {
      setNameError('Please enter a name with at least 3 letters.');
    } else {
      setNameError('');
    }

    // Improved Email Validation
  const emailPattern = /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;
  if (formData.email.trim() !== '' && !emailPattern.test(formData.email)) {
    setEmailError('Please enter a valid email address.');
  } else {
    setEmailError('');
  }

    if (formData.mobile.trim() !== '' && (formData.mobile.length !== 10 || !/^[0-9]+$/.test(formData.mobile))) {
      setMobileError('Please enter a valid 10-digit phone number.');
    } else {
      setMobileError('');
    }

    if (formData.subject.trim() !== '' && formData.subject.trim().length < 1) {
      setSubjectError('Please enter the subject.');
    } else {
      setSubjectError('');
    }

    if (formData.message.trim() !== '' && formData.message.trim().length < 1) {
      setMessageError('Please enter your message.');
    } else {
      setMessageError('');
    }
  }, [formData.name, formData.email, formData.mobile, formData.subject, formData.message]);

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasEmptyFields = false;

    if (!formData.name) {
      hasEmptyFields = true;
    }
    if (!formData.email) {
      hasEmptyFields = true;
    }
    if (!formData.mobile) {
      hasEmptyFields = true;
    }
    if (!formData.subject) {
      hasEmptyFields = true;
    }
    if (!formData.message) {
      hasEmptyFields = true;
    }

    if (hasEmptyFields) {
      toast.error('Please fill in all the fields.');
      return; // Stop further processing
    }

    let hasSpecificErrors = false;
    const emailRegex = /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;

    if (formData.name.trim().length < 3) {
      toast.error('Please enter a name with at least 3 letters.');
      hasSpecificErrors = true;
    }
    if (!emailRegex.test(formData.email.trim())) {
      toast.error('Please enter a valid email address.');
      hasSpecificErrors = true;
    }
  
    if (formData.mobile.length !== 10 || !/^[0-9]+$/.test(formData.mobile)) {
      toast.error('Please enter a valid 10-digit phone number.');
      hasSpecificErrors = true;
    }
    if (!formData.subject) {
      toast.error('Please enter the subject.');
      hasSpecificErrors = true;
    }
    if (!formData.message) {
      toast.error('Please enter your message.');
      hasSpecificErrors = true;
    }

    if (!hasSpecificErrors) {
      // Handle form submission logic here (e.g., sending to an API)
      console.log(formData);
    //  toast.success('Your message has been sent!'); // Optional success message
      setFormData({ name: '', email: '', mobile: '', subject: '', message: '' }); // Clear the form
    }

    emailjs
      .sendForm(
        'default_service',      // replace with your service ID
        'template_i2syw7g',     // replace with your template ID
        form.current,
        'X8hw3zSodzQIAevCJ'       // replace with your public key
      )
      .then((result) => {
        console.log(result.text);
        alert('Thanks for reaching out! Your message has been successfully sent and we will get back to you shortly.');
        setFormData({ name: '', email: '', mobile:'',subject:'', message: '' });
      })
      .catch((error) => {
        console.error(error.text);
        alert('Failed to send message. Please try again.');
      });
  };
  return (
    <div className="relative container mx-auto p-6 max-w-7xl lg:mt-20 mt-10"
    >
      <Helmet>
        <title>Contact Us - Nexify Infosystems</title>
        <meta name="description" content="Reach out to us for inquiries, support, or collaboration opportunities. We're here to assist you." />
        <meta name="keywords" content="contact, support, inquiries, business, collaboration, customer service" />
      </Helmet>

      <h2 className="text-[40px] font-[700] text-[#0e55a8] uppercase text-center">Get in touch</h2>
      <p className='text-[18px] text-[#222] font-[400] text-center'>Reach Out to Us Anytime – We're Here to Help!</p>
      <div className="flex flex-col lg:flex-row gap-10 mt-20 ">
        {/* Left Side - Form */}
        <div className="lg:w-1/2 w-full">
          <form ref={form}  onSubmit={handleSubmit} className="bg-opacity-80 p-6 rounded-sx shadow-md relative z-0 bg-[#f2f7fc]">
            <h2 className="text-2xl font-semibold mb-4 text-[#143749]">Ready to get started?</h2>

            <div className="mb-4">
              <label className="block mb-1 text-sm" htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder='Enter name'
                value={formData.name}
                onChange={handleChange}
                className={`border ${nameError ? 'border-red-500' : 'border-gray-300'} p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500`}
              />
              {nameError && <p className="text-red-500 text-xs italic">{nameError}</p>}
            </div>


            <div className="mb-4">
              <label className="block mb-1 text-sm" htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder='Enter email'
                className={`border ${emailError ? 'border-red-500' : 'border-gray-300'} p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500`}
              />
              {emailError && <p className="text-red-500 text-xs italic">{emailError}</p>}
            </div>
            <div className="mb-4">
              <label className="block mb-1 text-sm" htmlFor="mobile">Phone Number</label>
              <input
                type="tel"
                id="mobile"
                name="mobile"
                placeholder="Enter Phone Number"
                value={formData.mobile}
                maxLength={10}
                onChange={(e) => {
                  // Allow only digits
                  const cleaned = e.target.value.replace(/[^0-9]/g, '');
                  setFormData({ ...formData, mobile: cleaned });
                }}
                onKeyDown={(e) => {
                  // Block e, E, +, -, ., etc.
                  if (
                    ['e', 'E', '+', '-', '.'].includes(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
                className={`border ${mobileError ? 'border-red-500' : 'border-gray-300'} p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500`}
                />
                {mobileError && <p className="text-red-500 text-xs italic">{mobileError}</p>}
              </div>
            <div className="mb-4">
              <label className="block mb-1 text-sm" htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                placeholder='Enter subject'
                value={formData.subject}
                onChange={handleChange}
                className={`border ${subjectError ? 'border-red-500' : 'border-gray-300'} p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500`}
              />
              {subjectError && <p className="text-red-500 text-xs italic">{subjectError}</p>}
            </div>
            <div className="mb-4">
              <label className="block mb-1 text-sm" htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                placeholder='Message'
                value={formData.message}
                onChange={handleChange}
                className={`border ${messageError ? 'border-red-500' : 'border-gray-300'} p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500`}
                rows="4"
              />
              {messageError && <p className="text-red-500 text-xs italic">{messageError}</p>}
            </div>

            <button type="submit" className="w-full mt-6 p-3 bg-[#fb9d3d] text-white text-[16px] font-semibold rounded-lg hover:bg-[#fb9d3d] transition"
            >
              Submit Request
            </button>

          </form>
        </div>
        {/* Right Side - Contact Details with Images beside content */}
        <div className="lg:w-1/2 w-full flex flex-col gap-6">
          {/* First Row with two locations */}
          <div className="flex flex-wrap justify-start gap-2">
            <div className="flex items-start gap-4 p-2 transition-all duration-300 w-full lg:w-1/1">
              <img src={companyLocation} alt="Company Location USA" className="w-16 lg:w-20" />
              <div>
                <h2 className="font-semibold text-lg text-gray-800">Our Headquarters (USA)</h2>
                <p className="text-sm text-gray-600">
                  1600 Heritage Landing Suite # G212,
                  <br />
                  Saint Peters, Missouri 63303,
                  United States
                </p>

              </div>
            </div>

            <div className="flex items-start gap-4 p-2 transition-all duration-300 w-full lg:w-1/1">
              <img src={companyLocation1} alt="Company Location UK" className="w-16 lg:w-20" />
              <div>
                <h2 className="font-semibold text-lg text-gray-800">UK Office</h2>
                <p className="text-sm text-gray-600">
                  381 Midsummer Blvd,
                  <br />
                  Milton Keynes MK9 3HP,
                  <br />
                  United Kingdom
                </p>
              </div>
            </div>
          </div>

          {/* <div className="flex justify-start gap-6">
            <div className="flex items-start gap-4 p-2 transition-all duration-300 w-full lg:w-1/1">
              <img src={companyLocation2} alt="Company Location India" className="w-16 lg:w-20" />
              <div>
                <h2 className="font-semibold text-lg text-gray-800">India Office</h2>
                <p className="text-sm text-gray-600">
                  Flat No. 604, Annapurna Block,
                  <br />
                  Aditya Enclave, Ameerpet,
                  <br />
                  Hyderabad - 500016, Telangana, India.
                </p>
              </div>
            </div>
          </div> */}
          <div className="flex flex-col gap-6 mt-10  p-6">
            <h2 className="lg:text-[30px] text-[25px] font-[700] text-[#0e55a8]">Contact Information</h2>
            <div className="flex flex-col gap-4 text-[#222]">
              <p className='text-[16px]'><strong className='font-[500] text-[16px]'>Phone: </strong><a href="#">+1 732-612-9958</a></p>
              <p className='text-[16px]'><strong className='font-[500] text-[16px]'>General Inquiries:</strong> <a href="mailto:info@nexifyinfosystems.com" className="text-blue-500">info@nexifyinfosystems.com</a></p>
              <p className='text-[16px]'><strong className='font-[500] text-[16px]'>Careers:</strong> <a href="mailto:careers@Nexifyinfosystems.com" className="text-blue-500">careers@Nexifyinfosystems.com</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
